import { temAcesso } from '@/shared/auth/temAcesso'

const Relatorios = () => import('./Relatorios.vue')
const ComprometimentosSemRegistroPagamento = () =>
    import('./ComprometimentosSemRegistroPagamento.vue')
const RelacaoNotasFiscais = () =>
    import('./RelacaoNotasFiscais.vue')
const ComprometimentosPorContrato = () =>
    import('./ComprometimentosPorContrato.vue')
const ContratosPorGestor = () =>
    import('./ContratosPorGestor.vue')
const ValoresPagosPorContratos = () =>
    import('./ValoresPagosPorContratos.vue')
const ContratosAvisoSaldo = () =>
    import('./ContratosAvisoSaldo.vue')
const ValorTotalContratos = () =>
    import('./ValorTotalContratos.vue')
const ConsumoItens = () =>
    import('./ConsumoItensContrato.vue')
const ContratosVigentes = () =>
    import('./ContratosVigentes.vue')

export default {
    path: 'contratos/relatorios',
    name: 'Contratos_Relatorios',
    component: Relatorios,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CONT-REL-00')) {
            next()
        }
    },
    children: [
        {
            path: 'comprometimentossemregistropagamento',
            name: 'Contratos_Relatorios_ComprometimentosSemRegistroPagamento',
            component: ComprometimentosSemRegistroPagamento,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-01')) {
                    next()
                }
            }
        },
        {
            path: 'relacaonotasfiscais',
            name: 'Contratos_Relatorios_RelacaoNotasFiscais',
            component: RelacaoNotasFiscais,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-02')) {
                    next()
                }
            }
        },
        {
            path: 'comprometimentosporcontrato',
            name: 'Contratos_Relatorios_ComprometimentosPorContrato',
            component: ComprometimentosPorContrato,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-03')) {
                    next()
                }
            }
        },
        {
            path: 'contratosporgestor',
            name: 'Contratos_Relatorios_ContratosPorGestor',
            component: ContratosPorGestor,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-04')) {
                    next()
                }
            }
        },
        {
            path: 'valorespagosporcontratos',
            name: 'Contratos_Relatorios_ValoresPagosPorContratos',
            component: ValoresPagosPorContratos,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-05')) {
                    next()
                }
            }
        },
        {
            path: 'contratosavisosaldo',
            name: 'Contratos_Relatorios_ContratosAvisoSaldo',
            component: ContratosAvisoSaldo,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-06')) {
                    next()
                }
            }
        },
        {
            path: 'valortotalcontratos',
            name: 'Contratos_Relatorios_ValorTotalContratos',
            component: ValorTotalContratos,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-07')) {
                    next()
                }
            }
        },
        {
            path: 'consumoitenscontrato',
            name: 'Consumo_itens_contrato',
            component: ConsumoItens,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-08')) {
                    next()
                }
            }
        },
        {
            path: 'contratosvigentes',
            name: 'Contratos_vigentes',
            component: ContratosVigentes,
            beforeEnter: (to, from, next) => {
                    next()
            }
        }

    ]
}
